<div>
  Thanks for logging in! Your user has not been confirmed by the Well Chron team yet, if you believe you are receiving this message in error or would like to contact our team, please email
  {{ supportEmail }}.

  Thank you.

</div>
